// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class TrafficSummaryDayResponse implements flatbuffers.IUnpackableObject<TrafficSummaryDayResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TrafficSummaryDayResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTrafficSummaryDayResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: TrafficSummaryDayResponse,
  ): TrafficSummaryDayResponse {
    return (obj || new TrafficSummaryDayResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsTrafficSummaryDayResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: TrafficSummaryDayResponse,
  ): TrafficSummaryDayResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TrafficSummaryDayResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  timePeriod(): string;
  timePeriod(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  timePeriod(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  averageTime(): string;
  averageTime(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  averageTime(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  upHallCalls(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  downHallCalls(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  totalHallCalls(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat010(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat1130(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat3150(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat5170(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat7190(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  cat90Plus(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  static startTrafficSummaryDayResponse(builder: flatbuffers.Builder) {
    builder.startObject(11);
  }

  static addTimePeriod(builder: flatbuffers.Builder, timePeriodOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, timePeriodOffset, 0);
  }

  static addAverageTime(builder: flatbuffers.Builder, averageTimeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, averageTimeOffset, 0);
  }

  static addUpHallCalls(builder: flatbuffers.Builder, upHallCalls: number) {
    builder.addFieldInt32(2, upHallCalls, 0);
  }

  static addDownHallCalls(builder: flatbuffers.Builder, downHallCalls: number) {
    builder.addFieldInt32(3, downHallCalls, 0);
  }

  static addTotalHallCalls(builder: flatbuffers.Builder, totalHallCalls: number) {
    builder.addFieldInt32(4, totalHallCalls, 0);
  }

  static addCat010(builder: flatbuffers.Builder, cat010: number) {
    builder.addFieldInt32(5, cat010, 0);
  }

  static addCat1130(builder: flatbuffers.Builder, cat1130: number) {
    builder.addFieldInt32(6, cat1130, 0);
  }

  static addCat3150(builder: flatbuffers.Builder, cat3150: number) {
    builder.addFieldInt32(7, cat3150, 0);
  }

  static addCat5170(builder: flatbuffers.Builder, cat5170: number) {
    builder.addFieldInt32(8, cat5170, 0);
  }

  static addCat7190(builder: flatbuffers.Builder, cat7190: number) {
    builder.addFieldInt32(9, cat7190, 0);
  }

  static addCat90Plus(builder: flatbuffers.Builder, cat90Plus: number) {
    builder.addFieldInt32(10, cat90Plus, 0);
  }

  static endTrafficSummaryDayResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // time_period
    builder.requiredField(offset, 6); // average_time
    return offset;
  }

  static createTrafficSummaryDayResponse(
    builder: flatbuffers.Builder,
    timePeriodOffset: flatbuffers.Offset,
    averageTimeOffset: flatbuffers.Offset,
    upHallCalls: number,
    downHallCalls: number,
    totalHallCalls: number,
    cat010: number,
    cat1130: number,
    cat3150: number,
    cat5170: number,
    cat7190: number,
    cat90Plus: number,
  ): flatbuffers.Offset {
    TrafficSummaryDayResponse.startTrafficSummaryDayResponse(builder);
    TrafficSummaryDayResponse.addTimePeriod(builder, timePeriodOffset);
    TrafficSummaryDayResponse.addAverageTime(builder, averageTimeOffset);
    TrafficSummaryDayResponse.addUpHallCalls(builder, upHallCalls);
    TrafficSummaryDayResponse.addDownHallCalls(builder, downHallCalls);
    TrafficSummaryDayResponse.addTotalHallCalls(builder, totalHallCalls);
    TrafficSummaryDayResponse.addCat010(builder, cat010);
    TrafficSummaryDayResponse.addCat1130(builder, cat1130);
    TrafficSummaryDayResponse.addCat3150(builder, cat3150);
    TrafficSummaryDayResponse.addCat5170(builder, cat5170);
    TrafficSummaryDayResponse.addCat7190(builder, cat7190);
    TrafficSummaryDayResponse.addCat90Plus(builder, cat90Plus);
    return TrafficSummaryDayResponse.endTrafficSummaryDayResponse(builder);
  }

  unpack(): TrafficSummaryDayResponseT {
    return new TrafficSummaryDayResponseT(
      this.timePeriod(),
      this.averageTime(),
      this.upHallCalls(),
      this.downHallCalls(),
      this.totalHallCalls(),
      this.cat010(),
      this.cat1130(),
      this.cat3150(),
      this.cat5170(),
      this.cat7190(),
      this.cat90Plus(),
    );
  }

  unpackTo(_o: TrafficSummaryDayResponseT): void {
    _o.timePeriod = this.timePeriod();
    _o.averageTime = this.averageTime();
    _o.upHallCalls = this.upHallCalls();
    _o.downHallCalls = this.downHallCalls();
    _o.totalHallCalls = this.totalHallCalls();
    _o.cat010 = this.cat010();
    _o.cat1130 = this.cat1130();
    _o.cat3150 = this.cat3150();
    _o.cat5170 = this.cat5170();
    _o.cat7190 = this.cat7190();
    _o.cat90Plus = this.cat90Plus();
  }

  unpackFields(...fields: string[]): TrafficSummaryDayResponseT {
    const t = new TrafficSummaryDayResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("time_period")) {
      t.timePeriod = this.timePeriod();
    }
    if (fieldSet.has("average_time")) {
      t.averageTime = this.averageTime();
    }
    if (fieldSet.has("up_hall_calls")) {
      t.upHallCalls = this.upHallCalls();
    }
    if (fieldSet.has("down_hall_calls")) {
      t.downHallCalls = this.downHallCalls();
    }
    if (fieldSet.has("total_hall_calls")) {
      t.totalHallCalls = this.totalHallCalls();
    }
    if (fieldSet.has("cat_0_10")) {
      t.cat010 = this.cat010();
    }
    if (fieldSet.has("cat_11_30")) {
      t.cat1130 = this.cat1130();
    }
    if (fieldSet.has("cat_31_50")) {
      t.cat3150 = this.cat3150();
    }
    if (fieldSet.has("cat_51_70")) {
      t.cat5170 = this.cat5170();
    }
    if (fieldSet.has("cat_71_90")) {
      t.cat7190 = this.cat7190();
    }
    if (fieldSet.has("cat_90_plus")) {
      t.cat90Plus = this.cat90Plus();
    }
    return t;
  }
}

export class TrafficSummaryDayResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public timePeriod: string | Uint8Array | null = null,
    public averageTime: string | Uint8Array | null = null,
    public upHallCalls: number = 0,
    public downHallCalls: number = 0,
    public totalHallCalls: number = 0,
    public cat010: number = 0,
    public cat1130: number = 0,
    public cat3150: number = 0,
    public cat5170: number = 0,
    public cat7190: number = 0,
    public cat90Plus: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.timePeriod === null || this.timePeriod === undefined) {
      throw new Error('Required field "time_period" is not set');
    }
    if (this.averageTime === null || this.averageTime === undefined) {
      throw new Error('Required field "average_time" is not set');
    }
    const timePeriod = this.timePeriod !== null ? builder.createString(this.timePeriod!) : 0;
    const averageTime = this.averageTime !== null ? builder.createString(this.averageTime!) : 0;

    return TrafficSummaryDayResponse.createTrafficSummaryDayResponse(
      builder,
      timePeriod,
      averageTime,
      this.upHallCalls,
      this.downHallCalls,
      this.totalHallCalls,
      this.cat010,
      this.cat1130,
      this.cat3150,
      this.cat5170,
      this.cat7190,
      this.cat90Plus,
    );
  }

  clone(): TrafficSummaryDayResponseT {
    const obj = new TrafficSummaryDayResponseT();
    obj.timePeriod = this.timePeriod;
    obj.averageTime = this.averageTime;
    obj.upHallCalls = this.upHallCalls;
    obj.downHallCalls = this.downHallCalls;
    obj.totalHallCalls = this.totalHallCalls;
    obj.cat010 = this.cat010;
    obj.cat1130 = this.cat1130;
    obj.cat3150 = this.cat3150;
    obj.cat5170 = this.cat5170;
    obj.cat7190 = this.cat7190;
    obj.cat90Plus = this.cat90Plus;
    return obj;
  }

  equals(other: TrafficSummaryDayResponseT): boolean {
    if (this.timePeriod !== other.timePeriod) return false;
    if (this.averageTime !== other.averageTime) return false;
    if (this.upHallCalls !== other.upHallCalls) return false;
    if (this.downHallCalls !== other.downHallCalls) return false;
    if (this.totalHallCalls !== other.totalHallCalls) return false;
    if (this.cat010 !== other.cat010) return false;
    if (this.cat1130 !== other.cat1130) return false;
    if (this.cat3150 !== other.cat3150) return false;
    if (this.cat5170 !== other.cat5170) return false;
    if (this.cat7190 !== other.cat7190) return false;
    if (this.cat90Plus !== other.cat90Plus) return false;
    return true;
  }
}

export function verifyTrafficSummaryDayResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "time_period");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "average_time");
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 4);
    verifier.checkScalarField(tablePos, 22, 4);
    verifier.checkScalarField(tablePos, 24, 4);
  } finally {
    verifier.popDepth();
  }
}
